import React, { FC } from 'react'
import WelcomeLayout from '../../components/WelcomeLayout/WelcomeLayout'
import ErrorBadConnection from '../../components/Error/ErrorBadConnection'

const BadConnection: FC = () => {
	return (
		<WelcomeLayout>
			<ErrorBadConnection />
		</WelcomeLayout>
	)
}

export default BadConnection
